import list from "./list";
import fetchingNext from "./fetchingNext";
import subtypes from "./subtypes";
import filters from "./filters";

export default {
  list,
  fetchingNext,
  subtypes,
  filters,
};



// WEBPACK FOOTER //
// ./assets/list/reducers/index.js